import React from "react";
import InstrumentChoice from "./InstrumentChoice";
import { searchForFxPairUsingServer } from "../actions/searchForInstrumentsUsingServer";

const FxInstrument = (props) => (
    <div>
            <InstrumentChoice value={ props.value }
                              onChange={ chosenSearchResult => props.onChange(instrumentAttributes(chosenSearchResult))}
                              searchForInstrument={ searchForFxPairUsingServer }
                              className={props.className} />
    </div>
);
FxInstrument.propTypes = {
    className: React.PropTypes.string,
    onChange: React.PropTypes.func,
    value: React.PropTypes.shape({
        symbol: React.PropTypes.string,
        name: React.PropTypes.string
    })
};
FxInstrument.defaultProps = {
    value: {
        symbol: null,
        name: null
    }
};

function instrumentAttributes(chosenSearchResult) {
    return {
        instrumentId: chosenSearchResult.instrumentId,
        symbol: chosenSearchResult.pair,
        recommendableType: chosenSearchResult.recommendableType,
        name: chosenSearchResult.pair,
        recommendable: chosenSearchResult
    };
}

export default FxInstrument;



/** WEBPACK FOOTER **
 ** ./src/main/javascript/recorder/components/FxInstrument.js
 **/